document.addEventListener('DOMContentLoaded', () => {
    document.body.style.overflow = "hidden";

    const loaderContainer = document.getElementById('loader-container');
    const logo = document.getElementsByClassName('loading-logo');

    const GOLDEN_RATIO = (1 + Math.sqrt(5)) / 2;
    const RECIPROCAL_GR = 1 / GOLDEN_RATIO;
    const DURATION = RECIPROCAL_GR;

    const loaderFadeOutDuration = DURATION;
    const loaderFadeOutDelay = DURATION * 1.5;

    const BubblesScale = {
        desktop: 1.3,
        mobile: 0.5,
    };

    const BubbleSize = {
        BIG: "big",
        SMALL: "small",
    };

    const bubbleBig = 165;
    const bubbleSmall = 100;
    const bubbleSizes = [bubbleBig, bubbleSmall];
    const fixedTimeStep = 1 / 6;
    const physicsToDOMScale = 80;

    const bubbleProperties = {
        big: {
            mass: 12,
            yVelocity: 2.5,
        },
        small: {
            mass: 4,
            yVelocity: 6,
        },
    };

    function animateLogo() {
        const tl = gsap.timeline({
            smoothChildTiming: true,
            ease: 'power2.out',
            repeat: -1
        });

        tl.to(logo, {
            rotate: 6,
            duration: DURATION * 1.4
        });
        tl.to(
            logo,
            {
                y: "-1.6vw",
                delay: 0.05,
                duration: DURATION * 1.7
            },
            '<'
        );
        tl.to(
            logo,
            {
                rotate: 0,
                duration: DURATION * 1.8,
                ease: 'power2.out'
            },
            '>-80%'
        );
        tl.to(
            logo,
            {
                y: "0vw",
                duration: DURATION * 1.1,
                ease: 'power2.in'
            },
            '<50%'
        );

        tl.timeScale(1.2);
    }

    function fadeOutLoader() {
        const tl = gsap.timeline();

        tl.to(loaderContainer, {
            delay: loaderFadeOutDelay,
            autoAlpha: 0,
            duration: loaderFadeOutDuration
        });
        tl.to(
            loaderContainer.firstElementChild,
            {
                autoAlpha: 0,
                yPercent: -20,
                duration: loaderFadeOutDuration,
                onComplete: () => {
                    setupWarningDialog();
                }
            },
            `>-0.6`
        );

        tl.set(loaderContainer, { display: 'none' });

        return tl;
    }

    function generateBubbleMatrix(windowSize, scale) {
        const bubbleBig = bubbleSizes[0] * scale;
        const bubbleSmall = bubbleSizes[1] * scale;
        const isDesktop = scale === BubblesScale.desktop;
        const gap = bubbleBig / 5;
        const matrixRows = Math.round(windowSize[1] / bubbleBig) * (isDesktop ? 1 : 0.5);
        const matrixCols = Math.ceil(windowSize[0] / bubbleBig);
        const matrix = [];

        for (let i = 0; i < matrixRows; i++) {
            let x = 0;
            const y = i * bubbleBig + gap;
            const row = [];

            while (x < windowSize[0] - bubbleBig + gap) {
                const sizeWidth = bubbleSizes[Math.floor(Math.random() * bubbleSizes.length)] * scale;
                const size = sizeWidth === bubbleBig ? BubbleSize.BIG : BubbleSize.SMALL;
                x += sizeWidth + gap;
                row.push({
                    size,
                    x,
                    y: (size === BubbleSize.SMALL ? y + bubbleBig / 5 : y) + windowSize[1],
                });
            }

            if (x < windowSize[0] && windowSize[0] > x + bubbleSmall + gap) {
                row.push({
                    size: BubbleSize.SMALL,
                    x: x + bubbleSmall + gap,
                    y: y + bubbleBig / 5 + windowSize[1],
                });
            }

            matrix.push(row);
        }

        return { matrix, matrixRows, matrixCols };
    }

    function createBody(world, element, scale) {
        const rect = element.getBoundingClientRect();
        const size = element.dataset.size;
        const body = new p2.Body({
            mass: bubbleProperties[size].mass * scale,
            position: [
                (rect.left + rect.width / 2) / physicsToDOMScale,
                -(rect.top + rect.height / 2) / physicsToDOMScale,
            ],
            velocity: [0, Math.random() * bubbleProperties[size].yVelocity * scale],
            angle: Math.random() * 10,
        });
        const material = new p2.Material();
        const shape = new p2.Circle({
            radius: rect.width / 2 / physicsToDOMScale,
            material: material,
        });

        body.addShape(shape);
        world.addBody(body);

        const isDesktop = scale === BubblesScale.desktop;
        const sizeType = size === "big" ? 0 : 1;

        element.style.position = "absolute";
        element.style.top = "0";
        element.style.left = "0";
        element.style.zIndex = "10";
        element.style.transformOrigin = "50% 50%";
        element.style.borderRadius = "50%";
        element.style.width = `${bubbleSizes[sizeType] * scale}px`;
        element.style.height = `${bubbleSizes[sizeType] * scale}px`;
        element.style.backgroundColor = "#ffffff";
        element.style.opacity = "0";
        element.style.visibility = "hidden";
        element.style.border = `max(6px, .35vw) solid var(--color-black)`;

        gsap.to(element, {
            opacity: 0.95,
            duration: 1,
            delay: 0.5,
        });

        updateTransform(body, element);
    }

    function updateTransforms(world, elements) {
        elements.forEach((el, i) => {
            const body = world.bodies[i];
            if (!body) return;
            updateTransform(body, el);
        });
    }

    function updateTransform(body, element) {
        if (!body.shapes[0]) return;

        const x = physicsToDOMScale * (body.interpolatedPosition[0] - body.shapes[0].radius);
        const y = -physicsToDOMScale * (body.interpolatedPosition[1] + body.shapes[0].radius);

        const style = `translate(${x}px, ${y}px) rotate(${-body.interpolatedAngle * 57.2957795}deg)`;
        element.style.transform = style;
        element.style.visibility = "visible";
    }

    function initBubbleSimulation() {
        const container = document.getElementById("bubble-loader");
        if (!container) return;

        const windowSize = [window.innerWidth, window.innerHeight];
        const bubblesScale = windowSize[0] > 768 ? BubblesScale.desktop : BubblesScale.mobile;
        const { matrix, matrixRows, matrixCols } = generateBubbleMatrix(windowSize, bubblesScale);

        const world = new p2.World({
            gravity: [0, 1],
            broadphase: new p2.SAPBroadphase(),
        });

        container.innerHTML = "";

        matrix.forEach((row) => {
            row.forEach((bubble) => {
                const bubbleElement = document.createElement("div");
                bubbleElement.id = "loader-bubble";
                bubbleElement.dataset.size = bubble.size;
                bubbleElement.className = bubble.size;
                bubbleElement.style.position = "absolute";
                bubbleElement.style.left = `${bubble.x}px`;
                bubbleElement.style.top = `${bubble.y}px`;
                bubbleElement.style.width = `${bubbleSizes[bubble.size === BubbleSize.BIG ? 0 : 1] * bubblesScale}px`;
                bubbleElement.style.height = `${bubbleSizes[bubble.size === BubbleSize.BIG ? 0 : 1] * bubblesScale}px`;

                bubbleElement.innerHTML = `
                    <svg style="width: 100%; height: 100%;" viewBox="0 0 77 77" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.78029 38.065C1.37192 58.15 17.323 74.7632 37.408 75.1716c20.085.4083 36.6981-15.5427 37.1065-35.6277.4084-20.085-15.5427-36.69819-35.6277-37.10655C18.8018 2.02899 2.18865 17.98 1.78029 38.065Z" fill="#fff" stroke="#000" stroke-width="0" stroke-miterlimit="10"></path><path d="M47.5505 20.9866c3.7189 1.381 6.8037 4.2238 8.5438 7.8128 1.9951 4.126 1.8485 8.9578.0479 13.1033-.3807.8868.3705 1.9899 1.2113 2.2487 1.0332.3111 1.868-.3246 2.2487-1.2113 2.2059-5.0559 2.06-10.9574-.3533-15.9138-2.1579-4.4436-6.0782-7.811-10.6606-9.5238-2.1832-.818-3.221 2.6662-1.0378 3.4841Z" fill="#000"></path></svg>
                `;

                container.appendChild(bubbleElement);
                createBody(world, bubbleElement, bubblesScale);
            });
        });

        const body = document.body;
        const html = document.documentElement;
        const height = Math.max(
            body.scrollHeight * 2,
            body.offsetHeight * 2,
            html.clientHeight * 2,
            html.scrollHeight * 2,
            html.offsetHeight * 2
        );

        const planeBottomBody = new p2.Body({
            position: [0, (-height * 1.5) / physicsToDOMScale],
        });
        planeBottomBody.addShape(new p2.Plane());
        const planeTopBody = new p2.Body({ position: [0, 0] });
        planeTopBody.addShape(new p2.Plane(), [0, 0], Math.PI);
        const planeLeftBody = new p2.Body();
        planeLeftBody.addShape(new p2.Plane(), [0, 0], -Math.PI / 2);
        const planeRightBody = new p2.Body({
            position: [document.body.getBoundingClientRect().width / physicsToDOMScale, 0],
        });
        planeRightBody.addShape(new p2.Plane(), [0, 0], Math.PI / 2);

        world.addBody(planeBottomBody);
        world.addBody(planeTopBody);
        world.addBody(planeLeftBody);
        world.addBody(planeRightBody);

        let lastTimeMilliSeconds = 0;
        function update(timeMilliSeconds) {
            if (!world) return;

            const staticBubbles = world.bodies.filter(
                (body) => p2.vec2.length(body.velocity) < 0.5
            );
            if (staticBubbles.length > world.bodies.length / 1.1) {
                return world.bodies.forEach((body) => body.sleep());
            }

            requestAnimationFrame(update);
            if (lastTimeMilliSeconds) {
                const deltaTime = (timeMilliSeconds - lastTimeMilliSeconds) / 1000;
                world.step(fixedTimeStep, deltaTime, 1);
                updateTransforms(world, container.querySelectorAll("#loader-bubble"));
            }
            lastTimeMilliSeconds = timeMilliSeconds;
        }

        requestAnimationFrame(update);
    }

    window.addEventListener("resize", () => {
        document.getElementById("bubble-loader").innerHTML = "";
        initBubbleSimulation();
    });

    initBubbleSimulation();
    animateLogo();

    window.addEventListener('load', () => {
        fadeOutLoader();
        setTimeout(() => {
            document.body.style.overflow = "";
            document.querySelector("#shopify-header-group").style.visibility = "visible";
        }, 1000);
    })
});

const setupWarningDialog = () => {

    const storedChoice = getCookie("warningDialog");
    if (storedChoice === "allowed") {
        return;
    }

    setTimeout(() => {
        const body = document.querySelector("body")
        body.classList.add("loaded");
        const warningDialog = document.querySelector("#warning-dialog");
        warningDialog.setAttribute("data-state", "open");

        const redirectSetup = () => {
            const timer = document.querySelector(".timer");
            const intervalPromise = new Promise((res, rej) => {
                let count = 5;
                const interval = setInterval(() => {
                    count--;
                    timer.innerText = count;
                    if (count === 0) {
                        clearInterval(interval);
                        res();
                    }
                }, 1000)
            })

            intervalPromise.then(() => {
                window.location.replace("https://drinkwise.org.au/alcohol-and-your-health/#");
            })
        }

        if (storedChoice === "not-allowed") {
            warningDialog.setAttribute("data-state", "not-allowed");
            redirectSetup();
        }
        warningDialog.showModal();
        document.body.style.overflow = "hidden";

        const yesButton = document.querySelector(".yes-button");
        const noButton = document.querySelector(".no-button");
        const rememberCheckbox = document.querySelector("button[name='remember-choice']");

        const toggleCheckbox = () => {
            rememberCheckbox.classList.toggle("checked");
        }

        warningDialog.addEventListener("cancel", (e) => {
            e.preventDefault();
        })

        rememberCheckbox.addEventListener("click", toggleCheckbox);

        const closeDialog = () => {
            body.classList.remove("loaded");

            setTimeout(() => {
                warningDialog.classList.add("!slide-out")
                warningDialog.addEventListener("animationend", () => {
                    warningDialog.close();
                    warningDialog.setAttribute("data-state", "closed");
                    document.body.style.overflow = ""
                    warningDialog.classList.remove("!slide-out");
                });
            }, 300)
        }

        yesButton.addEventListener("click", () => {
            if (rememberCheckbox.classList.contains("checked")) {
                setCookie("warningDialog", "allowed", 7);
            }
            closeDialog();
        });

        noButton.addEventListener("click", () => {
            warningDialog.setAttribute("data-state", "not-allowed");

            redirectSetup();
        })

    }, 1200)
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}